/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SlugUpdateRequest
 */
export interface SlugUpdateRequest {
    /**
     * The new slug for the workspace
     * @type {string}
     * @memberof SlugUpdateRequest
     */
    slug: string;
}

/**
 * Check if a given object implements the SlugUpdateRequest interface.
 */
export function instanceOfSlugUpdateRequest(value: object): value is SlugUpdateRequest {
    if (!('slug' in value) || value['slug'] === undefined) return false;
    return true;
}

export function SlugUpdateRequestFromJSON(json: any): SlugUpdateRequest {
    return SlugUpdateRequestFromJSONTyped(json, false);
}

export function SlugUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SlugUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'slug': json['slug'],
    };
}

export function SlugUpdateRequestToJSON(json: any): SlugUpdateRequest {
    return SlugUpdateRequestToJSONTyped(json, false);
}

export function SlugUpdateRequestToJSONTyped(value?: SlugUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'slug': value['slug'],
    };
}

